<style>
.dynamic-form .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0px;
}
.dynamic-form .v-messages {
  min-height: 5px;
}
</style>

<template>
<div>
  <v-layout row wrap v-if="row && row.elements">

      <v-flex :class="element.class" v-for="element in row.elements" v-if="element.type != 'template'">
            <v-text-field autocomplete="off" pt-0 pb-0 v-if="element.type == 'input'" :label="element.label" v-model="element.model" placeholder=" " box></v-text-field>
            <v-textarea pt-0 pb-0 v-if="element.type == 'textarea'" :label="element.label" v-model="element.model" placeholder=" " box></v-textarea>
            <v-textarea pt-0 pb-0 v-if="element.type == 'html'" :label="element.label" v-model="element.model" placeholder=" " box></v-textarea>
            <v-checkbox  pt-0 pb-0 v-if="element.type == 'checkbox'" :label="element.label" v-model="element.model"></v-checkbox>
            <div v-if="element.type == 'file'"> {{ element.label}} : <input pt-0 pb-0  :label="element.label" :name='element.name' type="file" multiple /></div>
            <div v-if="element.type == 'html-content'" v-html="element.model"> </div>
      </v-flex>
      <!-- <v-flex class="text-xs-right" xs12 v-if="typeof row.multiple != 'undefined' && row.multiple" >
          <span class="text-xs-right caption" @click="appendRows(details.rows, index)">{{ row.multipleText }}</span>
      </v-flex> -->
  </v-layout>
</div>
</template>
<script>
import DynamicFormTable from '@/components/charts/form/dynamic-form/table.vue';
export default {
    data: function() {
        return {
            componentKey: 0
        };
    },
    props: ['chart', 'details', 'row', 'stepper'],
    components: {
      'dynamic-form-table': DynamicFormTable
    },
    methods: {
      removeRow(rows, index) {
              rows.splice(index, 1);
          },
      appendRows(rows, index) {
              let row = this.nullifyElements(rows[index]);
              console.log("element old", rows[index]);
              console.log("element new", row);
              rows.splice(index, 0, row);
          },
          nullifyElements(row) {
              let r = JSON.parse(JSON.stringify(row));
              for (let i = 0; i < r.elements.length; i++) {
                  r.elements[i].model = null;
              }
              return r;
          }
    },
    mounted() {

    }
}

</script>
